var map = {
	"./adds.png": "f51e",
	"./agree.png": "bf17",
	"./already.png": "4d0f",
	"./close.png": "9dc9",
	"./closed2.png": "b7b1",
	"./copy02.png": "617a",
	"./delivered.png": "134a",
	"./delivering.png": "7d21",
	"./dfh.png": "7f1a",
	"./dfwk.png": "8fac",
	"./disagree.png": "0585",
	"./dsh.png": "c460",
	"./dzf.png": "4ec5",
	"./exchange.png": "eb8a",
	"./explain.png": "92e2",
	"./failed.png": "0230",
	"./finish.png": "60e4",
	"./hhz.png": "af1e",
	"./jygb.png": "e065",
	"./jywc.png": "df93",
	"./logo.png": "1278",
	"./more.png": "0de8",
	"./more02.png": "f833",
	"./process.png": "c78a",
	"./ptz.png": "7ef5",
	"./refund.png": "c33f",
	"./register.png": "f693",
	"./rule.png": "1a81",
	"./selectpayway.png": "a4a7",
	"./sending.png": "6616",
	"./shipped.png": "e14b",
	"./shipped3.png": "5dbb",
	"./success.png": "8d73",
	"./tips.png": "86b9",
	"./tkz.png": "813d",
	"./transit.png": "070a",
	"./unfinished.png": "ef96",
	"./voice02.png": "8b10",
	"./wait.png": "4ccc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0134";